module.exports = __webpack_public_path__ + "static/networking-eb27c82674bb47a5c46f58405af21f09.png";